import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { appStoreMove } from 'src/utils/leaflet';
import { StyledHeader } from '../styles';
import { ICON_PATH, IMAGE_ROOT } from 'src/utils/constants';
import { leafletGaEvent } from 'src/utils/ga';
import { isMobile } from 'react-device-detect';

/**
 * @name 전단 허브 헤더
 */
function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const pageName = '전단헤더';

  const handleClickMain = () => {
    leafletGaEvent(pageName, '메인으로가기');
    navigate('/');
  };

  //앱다운받기 클릭
  const handleClickOpenApp = () => {
    leafletGaEvent(pageName, 'APP다운받기');
    // 앱 전단으로 이동
    const url = `${process.env.REACT_APP_GO_URL}/leaflet?leafletWv_yn=Y&hfrom=APP&rst1=J`;

    appStoreMove(url);
  };

  return (
    <StyledHeader>
      <div className="header_area">
        <div className="header_homebtn">
          {location.pathname !== '/' && (
            <button onClick={handleClickMain}>
              <img src={`${ICON_PATH}/icon_home.png`} alt="메인으로가기" />
            </button>
          )}
        </div>
        <h3>
          롯데마트GO에서 <br />더 많은 혜택을 만나보세요!
        </h3>
        <div className="header_appbtn">
          {isMobile && (
            <button onClick={handleClickOpenApp}>
              <img
                src={`${IMAGE_ROOT}/leaflet/common/leaflet_common_appBtn.png`}
                alt="앱 다운받기"
              />
            </button>
          )}
        </div>
      </div>
    </StyledHeader>
  );
}

export default Header;
